export default __webpack_public_path__ + "static/media/nicaragua.dfbf985d.png";